import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    width: '90%',
    margin: '0px 5%',
    textAlign: 'center',
    fontSize: 12,
    paddingTop: spacing(3),
    borderTop: `1px solid ${palette.grey.shade[30]}`,
    color: palette.grey.shade[90]
  },
  logo: {
    verticalAlign: 'bottom'
  }
}))
